<td :class="cellClass"><div><span>{{cellContent}}</span></div></td>